import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = ({ breakpoints, spacing, palette, mixins }: Theme) => ({
	root: {
		[breakpoints.up("md")]: {
			paddingLeft: 300
		}
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: "0 8px",
		...mixins.toolbar,
		[breakpoints.only("xs")]: {
			marginBottom: spacing(2)
		}
	},
	content: {
		flexGrow: 1,
		paddingTop: spacing(3),
		paddingBottom: spacing(3),
		[breakpoints.down("sm")]: {
			padding: spacing(1)
		}
	},
	title: {
		paddingRight: spacing(2),
		marginRight: spacing(2),
		borderRight: "1px solid #9AAD45"
	},
	pageTitle: {
		fontSize: 24,
		paddingRight: spacing(1),
		marginRight: spacing(1),
		borderRight: `1px solid ${palette.primary.main}`
	},
	breadcrumbs: {
		display: "flex"
	},
	dashboardIcon: {
		color: "#fff",
		stroke: `${palette.primary.main} !important`,
		marginBottom: "-6px"
	},
	link: {
		color: palette.primary.main
	}
});

export default makeStyles(styles);